import {
  Registration,
  TrainingsDto,
} from '~/scenes/MyWorkspace/components/Widgets/components/ApprovalWidget/types';
import { fetchFromOldApi } from '~/services/Http';

export const getEmployeeOncomingTrainings = (
  employeeId: number,
): Promise<TrainingsDto[]> =>
  fetchFromOldApi(
    `/json/dev/edu/company/trainings/employee/${employeeId}/oncoming`,
  ).then((r) => r.json());

export const approveTraining = (
  employeeId: number,
  registration: Registration,
): Promise<Registration> =>
  fetchFromOldApi(
    `/json/dev/edu/company/trainings/${employeeId}/participant/${registration.id}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ registration }),
    },
  ).then((r) => r.json());
